import { createFileRoute } from '@tanstack/react-router';
import ReferralsPage from '@/pages/referrals/ReferralsPage';
import { referralsSearchSchema } from '@/pages/referrals/search-schema';

export const Route = createFileRoute('/_authenticated/referrals/')({
  component: ReferralsPage,
  validateSearch: referralsSearchSchema,
});
